import React from 'react';
import { Popup, PopupProps } from 'semantic-ui-react';
import styles from './InfoTooltip.module.css';
import InfoIcon from 'components/Icons/InfoIcon';

export type InfoTooltiptProps = {
    title?: string;
    text?: string;
    trigger?: React.ReactNode;
    position?: PopupProps['position'];
};

const InfoTooltip = ({ title, text, trigger, position }: InfoTooltiptProps) => {
    return (
        <Popup
            trigger={trigger ?? <InfoIcon style={{ marginLeft: '4px' }} data-testid="popup" />}
            on="hover"
            inverted
            wide
            position={position}
        >
            {!!title && <p className={styles.title}>{title}</p>}
            {!!text && <p className={styles.message}>{text}</p>}
        </Popup>
    );
};

export default InfoTooltip;
